import { FilmFilterKey, ShowtimeFilterKey } from '@vista/omnichannel-components-domain';
import { useOccConfig } from '../context/occ/hooks/use-occ-config';
import { allFilterOptionValue } from '../utils/filters/constants';
/**
 * Filters an array of [[FilterOption]] entities based on the global [[OccFilterConfig]] and the provided [[FilterKey]].
 */
export const useFilterOptions = (options, filterKey, showAllOption) => {
    const { filter: { attributeIds, filmCategories } } = useOccConfig();
    const filteredOptions = getFilteredOptions(options, filterKey, attributeIds, filmCategories);
    if (!showAllOption)
        return filteredOptions;
    return [
        {
            value: allFilterOptionValue,
            selected: filteredOptions.every(option => !option.selected)
        },
        ...filteredOptions
    ];
};
const getFilteredOptions = (options, filterKey, attributeIds, filmCategories) => {
    if (filterKey === FilmFilterKey.Attribute || filterKey === ShowtimeFilterKey.Attribute) {
        return options.filter(option => !attributeIds || attributeIds.includes(option.value));
    }
    if (filterKey === FilmFilterKey.Category) {
        return filmCategories
            .map(category => options.find(option => option.value === category))
            .filter((option) => !!option);
    }
    return options;
};
